import React, {useState} from "react";
import {useRecoilState, useRecoilValue} from "recoil";
import {
  designUsingTreezState,
  treezDeltaUpdatesState,
  treezRestaurantsState
} from "../../state/atoms";
import {TreezDeltaUpdate} from "../../generated/dashboard-client";
import {approveAll, approveAllForDesignIds, ignore, onReviewApprove, Pos, review} from "../../service/PosService";
import GenericDesignUpdater from "./GenericDesignUpdater";

interface TreezDesignUpdaterProps {
  loading: boolean
}

const pos = Pos.Treez;

export default function TreezDesignUpdater({loading}: TreezDesignUpdaterProps) {
  const treezRestaurants = useRecoilValue(treezRestaurantsState);
  const [reviewDesignId, setReviewDesignId] = useState('');
  const [isReviewModal, setReviewModal] = useState(false);
  const [treezReviewUpdates, setTreezReviewUpdates] = useState([] as TreezDeltaUpdate[]);
  const [loadingDesignIds, setLoadingDesignIds] = useState([] as string[]);
  const [designsUsingTreez, setDesignsUsingTreez] = useRecoilState(designUsingTreezState);
  const [treezDeltaUpdates, setTreezDeltaUpdates] = useRecoilState(treezDeltaUpdatesState);
  const [optionsModalDesignId, setOptionsModalDesignId] = useState('');

  async function treezApproveAll(e: React.MouseEvent<HTMLElement>, designId: string) {
    await approveAll(e, designId, setLoadingDesignIds, setOptionsModalDesignId, designsUsingTreez, setDesignsUsingTreez, pos, treezRestaurants, treezDeltaUpdates, setTreezDeltaUpdates);
  }

  async function treezApproveAllForDesignIds(e: React.MouseEvent<HTMLElement>, designIds: string[]) {
    await approveAllForDesignIds(e, designIds, setLoadingDesignIds, setOptionsModalDesignId, designsUsingTreez, setDesignsUsingTreez, pos, treezRestaurants, treezDeltaUpdates, setTreezDeltaUpdates);
  }

  function treezReview(e: React.MouseEvent<HTMLElement>, designId: string) {
    review(e, designId, setReviewModal, setReviewDesignId, treezDeltaUpdates, setTreezReviewUpdates);
  }

  async function treezIgnore(e: React.MouseEvent<HTMLElement>, designId: string) {
    await ignore(e, designId, setLoadingDesignIds, treezRestaurants, pos, treezDeltaUpdates, setTreezDeltaUpdates, setOptionsModalDesignId, designsUsingTreez);
  }

  async function onTreezReviewApprove(ids: string[]) {
    await onReviewApprove(ids, setReviewModal, setLoadingDesignIds, reviewDesignId, treezRestaurants, treezDeltaUpdates, designsUsingTreez, setDesignsUsingTreez, pos, setTreezDeltaUpdates, setOptionsModalDesignId);
  }

  return <GenericDesignUpdater posReview={treezReview} posApproveAll={treezApproveAll} posApproveAllForDesignIds={treezApproveAllForDesignIds} posIgnore={treezIgnore}
                               deltaUpdates={treezDeltaUpdates} designs={designsUsingTreez} optionsModalDesignId={optionsModalDesignId}
                               reviewUpdates={treezReviewUpdates} loading={loading} loadingDesignIds={loadingDesignIds}
                               onReviewApprove={onTreezReviewApprove}
                               setOptionsModalDesignId={setOptionsModalDesignId} isReviewModal={isReviewModal} setReviewModal={setReviewModal}
                               restaurants={treezRestaurants} pos={pos}/>
}
